<template>
    <div>
      <CRow>
        <CCol xs="12" sm="12" md="12" lg="4" xl="3">
          <CCard>
            <CCardHeader class="d-flex justify-content-between">
              <b><i class="fas fa-calendar"></i>&nbsp;Cotizaciones</b>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol xs="12" sm="6" md="6" lg="12" v-if="$store.getters.get_rol.id !== 7">
                <CSelect
                  label="Sede: "
                  :value.sync="campu_id"
                  :options="data_campus"
                  placeholder="--Seleccione una sede--"
                  @change="handleCampusChange"
                />
              </CCol>
                <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                  <CInput label="Desde" type="date" aria-label="shift_date" @input="mtd_data" size="sm" id="init"
                    v-model="filter.init" />
                </CCol>
                <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                  <CInput label="Hasta" type="date" aria-label="shift_date" @input="mtd_data" id="end" size="sm"
                    v-model="filter.end" />
                </CCol>
                <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                  <CInput label="Total de Cotizaciones" type="text" size="sm" v-model="totalCotizaciones" disabled />
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs="12" sm="12" md="12" lg="8" xl="9">
          <CTableWrapper 
            :items="data" 
            :fields="fields" 
            hover 
            :striped="true" 
            :border="true" 
            small 
            fixed
            caption="Lista de Cotizaciones" 
            icon="fas fa-coins" 
            @mtdBack="mtdBack" 
            :size="'md'" 
            :actions="true" 
            :myButtons="myButtons" 
            @mtd_quote="mtd_quote" 
            :withActions="'2%'"
          />
        </CCol>
      </CRow>
  
    </div>
  </template>
  
  <script>
  const fields = [
    { key: "index", label: "Id", _style: "width:1%" },
    { key: "campu", label: "Sede", _style: "width:10%;" },
    { key: "client", label: "Cliente", _style: "width:10%;" },
    { key: "user", label: "Personal", _style: "width:10%;" },
    { key: "date_formatted", label: "Fecha", _style: "width:10%;" },
    { key: "serie", label: "Serie", _style: "width:10%;" },
    { key: "number", label: "Correlativo", _style: "width:10%;" },
    { key: "products", label: "Productos", _style: "width:15%;" },
    { key: "subtotal", label: "Subtotal", _style: "width:10%;" },
    { key: "discount_amount", label: "Descuento", _style: "width:10%;" },
    { key: "all_total", label: "Total", _style: "width:10%;" },
    /* { key: "payment_condition", label: "Método de pago", _style: "width:5%;" }, */
    /* { key: "status", label: "Estado", _style: "width:5%;" }, */
  ];
  
  import CTableWrapper from "../../../components/shared/datatable/Table.vue";
  import { mapActions } from "vuex";
  import moment from "moment";
  
  export default {
    components: {
      CTableWrapper,
    },
    data() {
      return {
        prefix: "quotes",
        fields,
        data: [],
        totalCotizaciones: 0,
        dataBarbers: [],
        filter: {
          init: null,
          end: null,
        },
  
        labelIcon: {
          labelOn: "\u2713",
          labelOff: "\u2715",
        },
        componentKey: 0,
        data_campus: [],
        campu_id: 0,
        myButtons: [
          {
            class: "btn-sm",
            color: "danger",
            tooltip: "Cotización",
            action: "mtd_quote",
            icon: "fas fa-file-pdf",
          },
        ],
      };
    },
    computed: {
      cpStatus: function () {
        if (this.companies.state == 1) return true;
        return false;
      },
    },
    created() {
      this.getCampus();
      moment.locale("es");
      this.filter.end = moment().format("YYYY-MM-DD");
      this.filter.init = this.filter.end;
      this.mtd_data();
    },
    methods: {
      ...mapActions(["get", "post"]),
      handleCampusChange() {
        this.mtd_data();
      },
      mtd_data() {
        if (!this.filter.init || !this.filter.end || this.filter.init > this.filter.end) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Por favor, selecciona un rango de fechas válido.',
          });
        }
        this.post({
          url: this.$store.getters.get__url + "/" + this.prefix,
          token: this.$store.getters.get__token,
          params: {
            init: this.filter.init,
            end: this.filter.end,
            campu_id: this.campu_id,
            company_id: this.$store.getters.get_company.id,
          },
        })
          .then((response) => {
            this.data = response.data.data;
            this.totalCotizaciones = this.data.length;
            let index = 1;
            this.data.forEach((item) => {
              item.index = index++;
              item.campu = item.campu_id ? item.campu.name : '-';
              item.user = item.user_id ? item.user.name+' '+item.user.last_name : 'Otros';
              item.client = item.client_id ? item.client.name : 'Cliente varios';
              item.date_formatted = moment(item.date).format("DD/MM/YYYY");
              item.serie = item.serie ? item.serie : '-';
              item.number = item.number ? item.number.toString().slice(-8).padStart(8, '0') : '-';
              let products = [];
              if (item.quotedetail && Array.isArray(item.quotedetail)) {
                products = item.quotedetail.map(detail => {
                  return `(${detail.quantity || 0}) ${detail.product?.name || 'Producto sin nombre'}`;
                });
              }
              item.products = products.join(", ");
              item.subtotal = parseFloat(item.total || 0).toFixed(2);
              item.discount_amount = item.discount_amount ? parseFloat(item.discount_amount).toFixed(2) : '0.00';
              item.all_total = parseFloat(item.total_payment || 0).toFixed(2);
              item.payment_condition = (item.payment_condition != null) ? item.payment_condition : 'No especificado';
              switch (item.state) {
                case 1:
                  item.status = "Registrado/Pagado";
                  break;
                case 2:
                  item.status = "Pendiente";
                  break;
                default:
                  item.status = "Desconocido";
              }
              
            });
          })
          .catch((errors) => {
            Swal.fire({
              title: errors,
              icon: "danger",
            });
          });
      },
      getCampus() {
        this.get({
          url:
            this.$store.getters.get__url +
            "/users/bycampus/" +
            this.$store.getters.get_company.id,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.statusCode == 200) {
            this.data_campus.push({
              label: "Todos",
              value: 0,
            });

            response.data.forEach((element) => {
              this.data_campus.push({
                label: element.name,
                value: element.id,
              });
            });
          }
        });
      },
      mtd_quote(item) {
        window.open(
          this.$store.getters.get__url + "/viewpdfQuotes/"+item.id, "_blank"
        );
      },
      mtdBack: function () {
        this.$emit("mtdBack");
      },
    },
  
  };
  </script>
  
  <style lang="scss" scoped></style>